import CustomSegment from '@/components/CustomSegment';
import PageTitle from '@/components/PageTitle';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import Canceled from './Canceled';
import Hired from './Hired';
import RedListed from './RedListed';
import SentOfferLetter from './SentOfferLetter';

export type HPSegmentType =
  | 'sent-offer-letter'
  | 'hired'
  | 'canceled'
  | 'red-listed';

export default function HiringPipeline() {
  const { segment, setSegment } = useSegment<HPSegmentType>(
    'recruitment-hiring-pipeline',
    'sent-offer-letter',
    false,
  );

  const SEGMENT_CONFIG: SegmentedType<HPSegmentType>[] = [
    {
      value: 'sent-offer-letter',
      label: 'Sent Offer  Letter',
      view: <SentOfferLetter />,
    },
    {
      value: 'hired',
      label: 'Hired',
      view: <Hired />,
    },
    {
      value: 'canceled',
      label: 'Canceled',
      view: <Canceled />,
    },
    {
      value: 'red-listed',
      label: 'Red listed',
      view: <RedListed />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Hiring Pipeline">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Jobs"
        items={[
          { title: 'Dashboard', path: '/admin/recruitment/dashboard' },
          { title: 'Hiring Pipeline' },
        ]}
      />
      {/* <Filters type={segment} /> */}

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
}
